export default __webpack_public_path__ + "static/media/BlueSide.6ff46876.svg";